import type { UseFormReturn } from 'react-hook-form';
import type { FormDefinition } from '@gov-design-system-ce/react-form-core';
import type { PeticePeticeDto } from '@gov-nx/api';
import type { EPeticeStep2Common } from '@gov-nx/module/page';
import { petitionAddresseeTemplateResolver } from '@gov-nx/ui/types';

export const setPetitionDetailsValues = <T extends EPeticeStep2Common>(
	form: FormDefinition<T>,
	{ perex, text, adresat }: PeticePeticeDto
): void => {
	const formMethods =
		form.formMethods as unknown as UseFormReturn<EPeticeStep2Common>;
	if (perex && perex.trim()) {
		formMethods.setValue('perex', perex.trim());
	}
	if (text && text.trim()) {
		formMethods.setValue('text', text.trim());
	}
	adresat &&
		formMethods.setValue('adresatOvm', {
			input: petitionAddresseeTemplateResolver(adresat),
			selected: adresat,
		});
};
